import DataPill from "@components/pills/DataPill";
import React from "react";

interface ExchangeManagementStatusPillProps {
  statusText: string;
}

const ExchangeManagementStausPill: React.FC<ExchangeManagementStatusPillProps> = ({
  statusText,
}) => {
  return <DataPill value={statusText} label={statusText} />;
};

export default ExchangeManagementStausPill;
